var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-sider',{class:[
    'sider',
    _vm.isDesktop() ? null : 'shadow',
    _vm.theme,
    _vm.fixSiderbar ? 'ant-fixed-sidemenu' : null,
  ],attrs:{"width":"230px","collapsible":_vm.collapsible,"trigger":null},model:{value:(_vm.collapsed),callback:function ($$v) {_vm.collapsed=$$v},expression:"collapsed"}},[(_vm.searchMenu)?_c('div',{staticClass:"search-menu"},[_c('a-input-search',{attrs:{"placeholder":"搜索"},on:{"change":_vm.onSearch}})],1):_vm._e(),(_vm.menus.length > 0)?_c('s-menu',{attrs:{"collapsed":_vm.collapsed,"menu":_vm.menus,"normal-menu":_vm.normalMenus,"theme":_vm.theme,"mode":_vm.mode},on:{"select":_vm.onSelect}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }